import Parse from "parse";

export function cancelDevicePairing(pairingRequestId) {
  return Parse.Cloud.run("cancelDevicePairing", { pairingRequestId });
}
